<div class="blast-vibration body-content">

  <!-- ── En-tête : recherche + filtre d'assignation + date + actions ───────── -->
  <div class="blast-vibration__header">


    <div class="date-nav">
      <app-calendar [ngModel]="selectedDate()" (ngModelChange)="onDateChange($event)" [size]="'small'"></app-calendar>
      <app-button variant="secondary" size="small" [addLabel]="false" [addIconLeft]="true" (clicked)="goPrev()">
        <img slot="icon-left" src="assets/icon/new_icon/arrow-left.svg" alt="" />
      </app-button>
      <app-button variant="secondary" size="small" [label]="'GLOBAL.TODAY' | translate" (clicked)="goToday()"></app-button>
      <app-button variant="secondary" size="small" [addLabel]="false" [addIconLeft]="true" (clicked)="goNext()">
        <img slot="icon-left" src="assets/icon/new_icon/arrow_right.svg" alt="" />
      </app-button>
      <app-select class="assignment-filter" [options]="assignmentOptions()" size="small"
      [ngModel]="assignmentFilter()"
      [placeholder]="'VIBRATION.ALL' | translate"
      (selectionChange)="onAssignmentFilterSelected($event)">
    </app-select>
    </div>

    <div class="header-actions">
      <app-button variant="secondary" size="small" [addIconLeft]="true" [label]="'VIBRATION.MULTI_ASSIGNMENT' | translate" (clicked)="openMultiAssign()">
        <img slot="icon-left" src="assets/icon/multi-assignment.svg" alt="" />
      </app-button>
      <app-button variant="primary" size="small" [addIconLeft]="true" [label]="'VIBRATION.ADD_RECORD' | translate" (clicked)="openAddRecord()">
        <img slot="icon-left" src="assets/icon/add-circle.svg" alt="" />
      </app-button>
    </div>
  </div>

  <!-- ── Onglets par measurement point ────────────────────────────────────── -->
  <div class="blast-vibration__tabs">
    <app-button class="tab tab--pinned" [variant]="activeControlPointId() === null ? 'primary' : 'secondary'" size="small"
      [label]="'VIBRATION.ALL' | translate" (clicked)="onTabClick(null)" [color]="'mint'">
    </app-button>
    <div class="tabs-track" #tabsTrack>
      @for (cp of assignedControlPoints(); track cp.controlPointId) {
        <app-button class="tab" [variant]="activeControlPointId() === cp.controlPointId ? 'primary' : 'secondary'" size="small"
          [label]="cp.name" (clicked)="onTabClick(cp.controlPointId)" [color]="'mint'">
        </app-button>
      }
    </div>
    @if (assignedControlPoints().length > 4) {
      <app-button variant="tertiary" size="small" [addLabel]="false" [addIconLeft]="true" (clicked)="scrollTabs(1)">
        <img slot="icon-left" src="assets/icons/arrow-right.svg" alt="" />
      </app-button>
    }
  </div>

  @if (viewState() === 'content') {

    <!-- ── Barre de sélection ────────────────────────────────────────────── -->
    <div class="selection-bar">
      <label class="select-all">
        <app-checkbox size="small" color="mint" [ariaLabel]="'GLOBAL.SELECT_ALL' | translate" [ngModel]="allSelected()" (ngModelChange)="toggleSelectAll()"></app-checkbox>
        <span>{{ 'GLOBAL.SELECT_ALL' | translate }}</span>
        @if (selectedCount() > 0) {
          <span class="select-count">({{ selectedCount() }})</span>
        }
      </label>

      <div class="selection-bar__actions">
        <app-button variant="tertiary" size="small" [addIconLeft]="true" [state]="selectedCount() === 0 ? 'disabled' : 'default'"
          [label]="'BUTTONS.DOWNLOAD' | translate" (clicked)="bulkDownload()">
          <img slot="icon-left" src="assets/icon/download.svg" alt="" />
        </app-button>
        <app-button variant="tertiary" size="small" [addIconLeft]="true" [state]="selectedCount() === 0 ? 'disabled' : 'default'"
          [label]="'BUTTONS.DELETE' | translate" (clicked)="askBulkDelete()">
          <img slot="icon-left" src="assets/icon/delete.svg" alt="" />
        </app-button>
        <app-button variant="tertiary" size="small" [addIconLeft]="true" [state]="!canBulkReport() ? 'disabled' : 'default'"
          [label]="'VIBRATION.REPORT' | translate" (clicked)="bulkReport()">
          <img slot="icon-left" src="assets/icon/report.svg" alt="" />
        </app-button>
      </div>
    </div>

    <!-- ── Liste : tableau générique ─────────────────────────────────────── -->
    <app-scrollable class="vib-table-scroll">
    <app-data-table class="vib-table"
      [data]="rows()"
      [columns]="tableColumns"
      rowKey="id"
      [equalColumns]="true"
      [expandable]="true"
      [expandedRowValue]="expandedRowId()"
      sortAscIcon="assets/icon/new_icon/arrow_full_down.svg"
      sortDescIcon="assets/icon/new_icon/arrow_full_up.svg"
      sortIconFilter="brightness(0)">

      <!-- En-tête « Channel N » avec navigation entre canaux -->
      <ng-template tableHeader="channel">
        <span class="vib-th-channel">
          {{ 'RECORD.CHANNEL' | translate }} {{ selectedChannelIndex() + 1 }}
          @if (maxChannelCount() > 1) {
            <app-button variant="tertiary" size="xsmall" [addLabel]="false" [addIconLeft]="true" (clicked)="cycleChannel(-1)">
              <img slot="icon-left" src="assets/icons/arrow-left.svg" alt="" />
            </app-button>
            <app-button variant="tertiary" size="xsmall" [addLabel]="false" [addIconLeft]="true" (clicked)="cycleChannel(1)">
              <img slot="icon-left" src="assets/icons/arrow-right.svg" alt="" />
            </app-button>
          }
        </span>
      </ng-template>

      <!-- Sélection -->
      <ng-template tableCell="select" let-row>
        <app-checkbox size="small" color="mint" [ariaLabel]="'GLOBAL.SELECT_ITEM' | translate: { name: row.dateLabel + ' ' + row.timeLabel }" [ngModel]="isSelected(row.id)" (ngModelChange)="toggleSelect(row.id)"></app-checkbox>
      </ng-template>

      <!-- Aperçu du canal courant -->
      <ng-template tableCell="channel" let-row>
        @if (previewFor(row, selectedChannelIndex()); as preview) {
          <img class="channel-cell__img" [src]="preview" alt="" />
        } @else if (sparklineFor(row, selectedChannelIndex()); as spark) {
          <div class="channel-cell">
            <div class="channel-cell__yaxis">
              <span>{{ spark.max | number:'1.1-1' }}</span>
              <span>{{ spark.min | number:'1.1-1' }}</span>
            </div>
            <div class="channel-cell__body">
              <svg viewBox="0 0 120 32" preserveAspectRatio="none" class="channel-cell__svg">
                <polyline [attr.points]="spark.points" fill="none" stroke="var(--c-amarante, #6c1d45)" stroke-width="1.2"></polyline>
              </svg>
              <div class="channel-cell__ticks">
                @for (t of spark.ticks; track $index) {
                  <span>{{ t }}</span>
                }
              </div>
            </div>
          </div>
        } @else {
          <span class="channel-cell__empty">-</span>
        }
        @if (expandedRowId() === row.id) {
          <div class="cell-extra">
            <div class="cell-extra__label">{{ 'VIBRATION.PPV_MAX' | translate }} (mm/s)</div>
            <div>{{ row.maxPpv | number:'1.2-2' }}</div>
          </div>
        }
      </ng-template>

      <!-- Date / heure -->
      <ng-template tableCell="timestampMs" let-row>
        <div class="col-timestamp">
          <div>{{ 'VIBRATION.DATE' | translate }} : {{ row.dateLabel }}</div>
          <div>{{ 'VIBRATION.TIME' | translate }} : {{ row.timeLabel }}</div>
          @if (expandedRowId() === row.id) {
            <div class="cell-extra">
              <div class="cell-extra__label">
                {{ 'RECORD.DISTANCE' | translate }}
                <app-button variant="tertiary" size="xsmall" [addLabel]="false" [addIconLeft]="true" (clicked)="openDistanceEdit(row)">
                  <img slot="icon-left" src="assets/icon/pencil.svg" alt="" />
                </app-button>
              </div>
              <div>{{ row.record.distance != null ? row.record.distance + ' m' : '-' }}</div>
            </div>
          }
        </div>
      </ng-template>

      <!-- Vibrations V / L / T / VS -->
      <ng-template tableCell="maxPpv" let-row>
        <div class="col-vibrations">
          @if (row.vAbs == null && row.lAbs == null && row.tAbs == null && row.picVibration != null) {
            <div>PPV : {{ row.picVibration | number:'1.2-2' }}</div>
          } @else {
            <div>V : {{ row.vAbs != null ? (row.vAbs | number:'1.2-2') : '-' }}  L : {{ row.lAbs != null ? (row.lAbs | number:'1.2-2') : '-' }}</div>
            <div>T : {{ row.tAbs != null ? (row.tAbs | number:'1.2-2') : '-' }}  VS : {{ row.vecSomme != null ? (row.vecSomme | number:'1.2-2') : '-' }}</div>
          }
          @if (expandedRowId() === row.id) {
            <div class="cell-extra">
              <div class="cell-extra__label">{{ 'RECORD.AIR_OVERPRESSURE' | translate }}</div>
              <div>Pa : {{ row.record.recordMetadata?.overpressure ?? '-' }}</div>
              <div>dB(L) : {{ row.overpressureDb != null ? (row.overpressureDb | number:'1.2-2') : '-' }}</div>
            </div>
          }
        </div>
      </ng-template>

      <!-- Notes -->
      <ng-template tableCell="notes" let-row>
        <div class="col-notes">
          <div class="notes-cell__text">
            @if (row.note1) { <div>{{ row.note1 }}</div> }
            @if (row.note2) { <div>{{ row.note2 }}</div> }
            @if (row.note3) { <div>{{ row.note3 }}</div> }
            @if (!row.note1 && !row.note2 && !row.note3) { <div class="notes-cell__empty">-</div> }
          </div>
          <app-button variant="tertiary" size="xsmall" [addLabel]="false" [addIconLeft]="true" (clicked)="openNotes(row)">
            <img slot="icon-left" src="assets/icon/pencil.svg" alt="" />
          </app-button>
        </div>
      </ng-template>

      <!-- Assignation : tir / point de mesure / device -->
      <ng-template tableCell="controlPointName" let-row>
        <div class="col-assignment">
          <div class="assignment-line"><img src="assets/icon/control-point-black.svg" alt="" />{{ row.controlPointName || ('RECORD.NO_MEASUREMENT_POINT' | translate) }}</div>
          <div class="assignment-line"><img src="assets/icon/device.svg" alt="" />{{ row.deviceLabel }}</div>
          <!-- Téléchargement du fichier : uniquement quand la ligne est dépliée -->
          @if (expandedRowId() === row.id) {
              <app-button class="vib-open__download" variant="secondary" size="xsmall"
                [label]="'VIBRATION.DOWNLOAD_SIS_FILE' | translate"
                [addLabel]="true" [addIconLeft]="true"
                [title]="'BUTTONS.DOWNLOAD' | translate"
                [state]="row.record.recordMetadata?.fileName ? 'default' : 'disabled'"
                (clicked)="downloadFile(row)"> 
                <img slot="icon-left" src="assets/icon/download.svg" alt="" />
              </app-button>
          }
        </div>
      </ng-template>

      <!-- Dépliage -->
      <ng-template tableCell="expand" let-row>
        <app-button class="col-expand" variant="tertiary" size="xsmall" [addLabel]="false" [addIconLeft]="true" (clicked)="toggleExpand(row)">
          <img slot="icon-left" [src]="expandedRowId() === row.id ? 'assets/icon/chevron-up.svg' : 'assets/icon/chevron-down.svg'" alt="" />
        </app-button>
      </ng-template>

      <!-- ── Ligne dépliée ("Open") ──────────────────────────────────────── -->
      <ng-template tableRowDetail let-row>
        <div class="vib-open">
          <div class="vib-open__left">
            <app-blast-vibration-chart
              [siteId]="siteId()"
              [eventId]="row.record.eventId"
              [tirName]="tirName()"
              [siteName]="siteName()"
              [vibrationRecord]="row.record"
              [ponderationTypes]="ponderations()">
            </app-blast-vibration-chart>
          </div>

          <div class="vib-open__right">

            <div class="assign-card">
              <div class="assign-card__title">
                <img src="assets/icons/blast.svg" alt="" />{{ 'RECORD.BLAST' | translate }}
              </div>
              <div class="assign-card__value">{{ tirName() }}</div>
              <div class="assign-card__actions">
                <app-button variant="secondary" size="xsmall" state="disabled" [label]="'BUTTONS.MODIFY' | translate"></app-button>
                <app-button variant="tertiary" size="xsmall" [label]="'BUTTONS.UNASSIGN' | translate" (clicked)="unassignFromBlast(row)"></app-button>
              </div>
            </div>

            <app-blast-records-assignment
              [siteId]="siteId()"
              [isControlPointAssigned]="!!row.record.controlPointId"
              [vibrationRecord]="row.record"
              [controlPoints]="controlPoints()"
              [deviceRef]="row.deviceLabel">
            </app-blast-records-assignment>



            <div class="vib-open__actions">
              <app-button variant="tertiary" size="xsmall" [label]="'VIBRATION.VIEW_VIBRADATA' | translate" (clicked)="viewInVibraData(row)"></app-button>
              <app-button variant="tertiary" size="xsmall" color="semantic-red" [label]="'VIBRATION.DELETE_RECORD' | translate" (clicked)="askDeleteSingle(row)"></app-button>
            </div>
          </div>
        </div>
      </ng-template>

    </app-data-table>
    </app-scrollable>
  }

  @if (viewState() === 'loading') {
    <div class="state-container">
      <i class="fas fa-spinner fa-spin"></i>
      <span>{{ 'GLOBAL.CHARGEMENT' | translate }}...</span>
    </div>
  }

  @if (viewState() === 'empty') {
    <div class="state-container">
      <p>{{ 'RECORD.NO_RECORDS' | translate }}</p>
    </div>
  }

</div>

<!-- ── Nouvel enregistrement ─────────────────────────────────────────────── -->
<app-blast-record-modal
  [isOpen]="addRecordOpen()"
  [siteId]="siteId()!"
  [blastId]="blastId()"
  [siteName]="siteName()"
  [regionName]="regionName()"
  [controlPoints]="controlPoints()"
  (closed)="closeAddRecord()"
  (saved)="reload()">
</app-blast-record-modal>

<!-- ── Multi-affectation ────────────────────────────────────────────────── -->
<app-blast-assign-records-modal
  [isOpen]="multiAssignOpen()"
  [siteId]="siteId()!"
  [blastId]="blastId()"
  [tirName]="tirName()"
  [tirDate]="tirDate()"
  (closed)="closeMultiAssign()"
  (assigned)="reload()">
</app-blast-assign-records-modal>

<!-- ── Édition des notes ─────────────────────────────────────────────────── -->
<app-popup [isOpen]="noteEditRowId() !== null" size="medium" [color]="'mint'" [title]="'VIBRATION.NOTES' | translate" (closed)="closeNotes()" variant="secondary">
  <div class="popup-form">
    <app-input placeholder="Note 1" [ngModel]="noteDraft().note1" (ngModelChange)="updateNoteDraft('note1', $event)"></app-input>
    <app-input placeholder="Note 2" [ngModel]="noteDraft().note2" (ngModelChange)="updateNoteDraft('note2', $event)"></app-input>
    <app-input placeholder="Note 3" [ngModel]="noteDraft().note3" (ngModelChange)="updateNoteDraft('note3', $event)"></app-input>
    <app-button variant="primary" size="small" [color]="'mint'" [label]="'VIBRATION.CONFIRM' | translate" (clicked)="saveNotes()"></app-button>
  </div>
</app-popup>

<!-- ── Édition de la distance ────────────────────────────────────────────── -->
<app-popup [isOpen]="distanceEditRowId() !== null" size="small" [color]="'mint'" [title]="'RECORD.DISTANCE' | translate" (closed)="closeDistanceEdit()" variant="secondary">
  <div class="popup-form">
    <app-input type="number" suffix="m" [ngModel]="distanceDraft()" (ngModelChange)="updateDistanceDraft($event)"></app-input>
    <app-button variant="primary" size="small" [color]="'mint'" [label]="'VIBRATION.CONFIRM' | translate" (clicked)="saveDistance()"></app-button>
  </div>
</app-popup>

<!-- ── Confirmation de suppression ───────────────────────────────────────── -->
<app-popup [isOpen]="pendingDeleteIds() !== null" size="xsmall" [title]="'GLOBAL.CONFIRMATION_SUPPRESSION' | translate" (closed)="cancelDelete()" variant="secondary">
  <div class="delete-confirm">
    <p>{{ 'GLOBAL.CONFIRMATION_SUPPRESSION' | translate }}</p>
    <div class="delete-confirm__actions">
      <app-button variant="primary" size="small" color="semantic-red" [label]="'GLOBAL.OUI' | translate" (clicked)="confirmDelete()"></app-button>
      <app-button variant="secondary" size="small" [label]="'GLOBAL.NON' | translate" (clicked)="cancelDelete()"></app-button>
    </div>
  </div>
</app-popup>
